<div class="flex min-h-full flex-auto flex-col content-stretch items-stretch justify-stretch">
  <sparrow-admin-header />
  <div class="flex w-full flex-auto flex-col self-center p-6">
    <router-outlet></router-outlet>
  </div>
</div>
